import { PAYMENT_SCHEDULES, take } from "utils";
import { ScheduleTypeEnum } from "types";

const currencyStringToFloat = (currencyString: string): number =>
  parseFloat(currencyString.replace(/,/g, ""));

const wageSchedules = take(PAYMENT_SCHEDULES, [
  ScheduleTypeEnum.WEEKLY,
  ScheduleTypeEnum.BI_WEEKLY,
  ScheduleTypeEnum.MONTHLY,
  ScheduleTypeEnum.NTH_WEEKDAY,
  ScheduleTypeEnum.TWICE_MONTHLY,
]);

const schedules = {
  ...take(PAYMENT_SCHEDULES, [ScheduleTypeEnum.PARTICULAR_DAY]),
  ...wageSchedules,
};

export { currencyStringToFloat, schedules, wageSchedules };
